export const lightTheme = {
	bg: 'rgb(247,248,250)',
	bgf: 'rgb(255,255,255)',
	bgAlpha: 'rgba(250,250,250,.3)',
	bgAlpha2: `rgba(160,160,160,.3)`,
	bg2: 'rgb(245,245,245)',
	bg3: 'rgb(230,230,230)',
	text: 'rgb(45,45,45)',
	bgText: `rgb(116, 116, 116)`,
	primary: '#00D4AA',
	accent: '#00D4AA',
	highlight: 'rgb(150,150,150)',
	strongHighlight: 'rgb(0,0,0)'
}

export const darkTheme = {
	bg: '#08090c',
	bgf: '#0c0d10',
	bgAlpha: 'rgba(0,0,0,.35)',
	bgAlpha2: `rgba(80,80,80,.25)`,
	bg2: '#16181d',
	bg3: '#25282f',
	text: '#e4e6eb',
	bgText: '#8b8f98',
	primary: '#00D4AA',
	accent: '#00D4AA',
	highlight: '#a0a4ad',
	strongHighlight: '#ffffff'
}
